export class PershingError {
    public errorMessage: string;
    public errorCode: string;
    public className: string;
    public timestamp: string;

    constructor(errorMessage: string, className: string, errorCode?: string) {
        this.errorMessage = errorMessage;
        this.className = className;
        this.errorCode = errorCode;
        this.timestamp = new Date().toString();
    }
}
